import "./App.css";

import Strip from "./router/strip";

function App() {
  return (
    <div className="App">
      <Strip />
    </div>
  );
}

export default App;
